/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'text!./templates/FilterView.html',
	'react-dom',
	'react',
	'underscore',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-common-components/lib/filters',
	'../../lib/@waca/dashboard-common/dist/utils/EventChainLocal',
	'../../util/KeyCodes',
	'../../widgets/livewidget/nls/StringResources'
],
function (View,  FilterTemplate,  ReactDOM, React, _, Toolkit, CaFilters, EventChainLocal, KeyCodes, StringResources) {
	'use strict';
	var FilterBaseView = View.extend({
		reactViewClass: '',
		compactReactViewClass: '',
		templateString: FilterTemplate,
		FilterViewLib: CaFilters || {},

		init: function(options) {
			FilterBaseView.inherited('init', this, arguments);

			var userPreferences = options.dashboardApi.getGlassCoreSvc('.UserProfile').preferences;
			this.locale = userPreferences.productLocale || 'en';
			this.timeZoneID = userPreferences.timeZoneID || 'Etc/UTC';
			this.isCompact = options.isCompact;
			this.commonView = options.commonView;
			this.model = options.model;

			this.options = options; //TODO: Extract only callbacks;
			this.$el.on('keyup keydown', 'button, input, .ba-common-list', this._keyHandler.bind(this));
			if (CaFilters && CaFilters.initGlassContext) {
				options.dashboardApi.prepareGlassOptions(options);
				CaFilters.initGlassContext(options.glassContext);
			}
		},

		renderViewComposition: function(){
			var viewModel = {
				viewClass: this._getReactViewName()
			};
			return this.commonView.renderInFilterItemView(viewModel).then(function(viewOptions){
				this.mountNode = viewOptions.mountNode;
				this._createContainerDiv();
				this._renderCommonView();
				this.model.on('all', this._renderCommonView.bind(this));
			}.bind(this));
		},

		_createContainerDiv: function() {
			var sHtml = this.dotTemplate({
				name: this.model.getName ? this.model.getName() : this.model.name,
				commonFilterViewClass: this._getReactViewName()
			});
			this.$el.html(sHtml);
			this.$el.appendTo(this.mountNode);
		},

		_getCommonViewMountNode: function(){
			return this.$el.find('.commonFilterControlContainer')[0];
		},

		_renderCommonView: function () {
			if (!this._getCommonViewMountNode()) {
				// create the container div only once.
				this._createContainerDiv();
			}

			let sharedProps = {
				isDirty: this.model.savedState? !_.isEqual(this.model.savedState, JSON.stringify(this.model.toJSON())): false,
				invertDisabled: this._getInvertDisabled(),
				isSearching: this.model.get('isSearching') ? this.model.get('isSearching'): false,
				menuTitle: StringResources.get('filterOverflowMenu'),
				showHeader: !(this.options.showHeader===false),
				autoFocus: true
			};

			this._renderReactControl(sharedProps);
		},

		_renderReactControl(sharedProps) {
			var props =  _.extend(this._getCommonViewProps(), this._getCommonViewCallbacks(), sharedProps);
			ReactDOM.render(React.createElement(Toolkit['Root'], null, React.createElement(this.FilterViewLib[this._getReactViewName()], props)), this._getCommonViewMountNode());
		},

		/**
		 * Get the view props passed to the react component
		 *
		 * @return {object}
		 */
		getViewProps: function() {
			return _.extend(this._getCommonViewProps(), this._getCommonViewCallbacks());
		},

		_getReactViewName: function() {
			return this.isCompact ? this.compactReactViewClass : this.reactViewClass;
		},

		doRender: function() {
			this._renderCommonView();
		},
		/**
			 * @param skipRender	if true render is not called
			 */
		resetView: function(skipRender) {
			var mountNode = this._getCommonViewMountNode();
			if (mountNode) {
				ReactDOM.unmountComponentAtNode(mountNode);
			}

			if (!skipRender) {
				this.doRender();
			}
		},

		isOpen: function() {
			return this.$el && this.$el.find('.commonFilterControlContainer').is(':visible');
		},

		remove: function() {
			this.resetView( /*skipRender*/ true);
			if (this.commonView && this.commonView.onViewClose) {
				this.commonView.onViewClose();
			}
			FilterBaseView.inherited('remove', this);
		},
		_onClear: function() {
			this.options.cbOnClear();
		},
		_onChange: function(props) {
			this.options.cbOnChange(props);
		},
		_onDone: function() {
			this.options.cbOnDone();
		},
		_onApply: function() {
			this.options.cbOnApply();
		},
		_onClose: function() {
			this.options.cbOnClose();
		},
		_onSearch: function(payload) {
			var trimmed = (payload || '').trim();
			this.options.cbOnSearch(trimmed);
		},
		_onClick: function(payload) {
			this.options.cbOnClick(payload);
		},
		_getValue: function(payload) {
			return this.options.cbGetValue(payload);
		},
		_getInvert: function() {
			this.options.cbGetInvert();
		},
		_onToggleChange: function(payload) {
			this.options.cbOnToggleChange(payload);
		},
		_getInvertDisabled: function() {
			if(this.options.cbGetInvertDisabled) {
				return this.options.cbGetInvertDisabled();
			}
		},

		_isArrowKey: function(keyCode) {
			return keyCode == KeyCodes.KEY_LEFT ||
					keyCode == KeyCodes.KEY_UP ||
					keyCode == KeyCodes.KEY_RIGHT ||
					keyCode == KeyCodes.KEY_DOWN;
		},

		_keyHandler: function(event) {
			if(this._isArrowKey(event.keyCode)) {
				let eventChainLocal = new EventChainLocal(event);
				eventChainLocal.setProperty('preventMoveAction', true);
			}
		}
	});
	return FilterBaseView;
});
